/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaListPrefixResponse } from '../../models/media-list-prefix-response';

export interface MediaControllerListFolders$Params {
  prefix: string;
}

export function mediaControllerListFolders(http: HttpClient, rootUrl: string, params: MediaControllerListFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaListPrefixResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerListFolders.PATH, 'get');
  if (params) {
    rb.query('prefix', params.prefix, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaListPrefixResponse;
      }>;
    })
  );
}

mediaControllerListFolders.PATH = '/file-manager/folder';
